export const TIME_FROM_TO_SEPARATOR = "\t";


// WEBPACK FOOTER //
// ./src/constants/separator.js